import { createGlobalStyle } from '../styled-components'

export default createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  
  :root {
    --reach-dialog:1
  }

  [data-reach-dialog-overlay] {
    background: rgba(0,0,0,.33);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow:auto;
    z-index: 1040;
  }
  
  [data-reach-dialog-content] {
    width: 50vw;
    margin: 20vh auto;
    background: #fff;
    padding: 2rem;
    outline:none;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  
  #root label {
    margin-bottom: 0;
  }
`
